export default "__VITE_ASSET__CeuygE_9__"